const snapshotComparisonStyles = {
  page: {
    mt: 10,
    px: 2,
    pb: 2
  },
  tableContainer: {
    mt: 3,
    height: 640,
    position: 'relative'
  },
  summary: {
    mt: 0.5
  },
  errorContainer: {
    mt: 2
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 2
  },
  detailFilters: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 2,
    mt: 2
  },
  textButton: {
    textTransform: 'none'
  },
  linkButton: {
    textTransform: 'none',
    color: 'primary.main'
  },
  saveButton: {
    textTransform: 'none',
    color: 'black.main'
  },
  snackbarAlert: {
    width: '100%'
  },
  applicationNumberCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5
  },
  scrollableCell: {
    maxHeight: 120,
    overflowY: 'auto',
    whiteSpace: 'pre-wrap',
    width: '100%',
    fontSize: 13,
    py: 1
  },
  wrappedCell: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    width: '100%',
    fontSize: 13,
    py: 1,
    lineHeight: 1.4
  },
  sectionsChangedCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 0.5,
    width: '100%',
    maxHeight: 120,
    overflowY: 'auto',
    overflowX: 'hidden',
    py: 0.5
  },
  sectionsChangedChip: {
    maxWidth: '100%',
    height: 'auto',
    '& .MuiChip-label': {
      whiteSpace: 'normal',
      display: 'block',
      py: 0.5
    }
  },
  verdictChip: {
    fontWeight: 600
  },
  comparisonCell: {
    whiteSpace: 'normal',
    lineHeight: 'normal',
    display: 'flex',
    alignItems: 'center',
    overflow: 'visible'
  },
  pinnedComparisonGrid: {
    // Header row scrolls via transform in DataGrid v5; hide the moving title and use pinnedComparisonHeader overlay.
    '& .MuiDataGrid-columnHeader[data-field="comparison"] .MuiDataGrid-columnHeaderTitleContainerContent':
      {
        visibility: 'hidden'
      },
    '& .MuiDataGrid-columnHeader[data-field="comparison"]': {
      bgcolor: 'background.paper'
    },
    '& .MuiDataGrid-cell[data-field="comparison"]': {
      position: 'sticky',
      left: 0,
      zIndex: 4,
      // Opaque fill so horizontally scrolled cells cannot show through the pinned column.
      bgcolor: 'background.paper',
      boxShadow: '2px 0 4px -2px rgba(0,0,0,0.15)'
    },
    // MUI `action.hover` is translucent; use solid grey so hover does not reveal overlapped text.
    '& .MuiDataGrid-row:hover .MuiDataGrid-cell[data-field="comparison"]': {
      bgcolor: 'grey.100'
    },
    '& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell[data-field="comparison"]': {
      bgcolor: 'grey.200'
    },
    '& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell[data-field="comparison"]': {
      bgcolor: 'grey.300'
    }
  },
  pinnedComparisonHeader: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: 'background.paper',
    fontWeight: 'bold',
    fontSize: '16px',
    boxShadow: '2px 0 4px -2px rgba(0,0,0,0.15)',
    borderBottom: 1,
    borderColor: 'divider',
    pointerEvents: 'none'
  },
  compareModal: {
    dialogPaper: {
      width: 1200,
      maxWidth: 'calc(100% - 32px)',
      height: 720,
      maxHeight: 720,
      m: 1
    },
    letterDialogPaper: {
      width: 1400,
      maxWidth: 'calc(100% - 32px)',
      height: 720,
      maxHeight: 720,
      m: 1
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden'
    },
    header: {
      p: 2,
      borderBottom: 1,
      borderColor: 'divider',
      flexShrink: 0
    },
    tabsBar: {
      px: 2,
      pt: 0.5,
      borderBottom: 1,
      borderColor: 'divider',
      flexShrink: 0
    },
    title: {
      mb: 1.5
    },
    tabs: {
      minHeight: 40,
      '& .MuiTab-root': { minHeight: 40 }
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      p: 0
    },
    panelsContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0
    },
    letterBody: {
      display: 'flex',
      flex: 1,
      minHeight: 0
    },
    letterPdfPane: {
      flex: 1,
      minWidth: 0,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column'
    },
    letterFormPane: {
      width: 320,
      flexShrink: 0,
      borderLeft: 1,
      borderColor: 'divider',
      p: 2,
      overflowY: 'auto'
    },
    panelsStack: {
      flex: 1,
      minHeight: 0
    },
    footer: {
      px: 1.5,
      py: 0.75,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 1,
      borderTop: 1,
      borderColor: 'divider',
      flexShrink: 0
    },
    footerWithNav: {
      justifyContent: 'space-between'
    },
    letterNav: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1
    },
    letterActions: {
      display: 'flex',
      alignItems: 'center',
      gap: 1
    }
  }
};

export default snapshotComparisonStyles;
